import { SxStyle } from '../../../types/style';

const contentContainer: SxStyle = {
    padding: 2,
    minHeight: 'calc(100vh - 55px)'
};

const contentContainerGrid: SxStyle = {
    justifyContent: 'center',
    alignItems: 'center'
}

const contentContainerGridItem1Typography: SxStyle = {
    fontWeight: 700
}

const contentContainerGridItem2Paper: SxStyle = {
    marginTop: '10px'
}

// columns datagrid
const dataGridBox: SxStyle = {
    minWidth: '50px',
    width: '50px', 
    height: '30px', 
    borderRadius: '5px', 
    marginRight: '14px', 
    marginLeft: '14px'
}

// actions datagrid
const dataGridMenuMenuItemListItemIcon: SxStyle = {
    minWidth: '30px'
}


export const articleStyle = {
    contentContainer,
    contentContainerGrid,
    contentContainerGridItem1Typography,
    contentContainerGridItem2Paper,
    dataGridBox,
    dataGridMenuMenuItemListItemIcon
};